<template>
	<div class="prize-edit">
		<div class="title">
			<v-flex>
				<v-text-field v-model="prize.title" label="Title"></v-text-field>
			</v-flex>
			<v-flex>
				<v-btn @click="handlePrizeMoveUp()" icon :disabled="disableMoveUp" tabindex="-1">
					<v-icon>arrow_upward</v-icon>
				</v-btn>
				<v-btn @click="handlePrizeMoveDown()" icon :disabled="disableMoveDown" tabindex="-1">
					<v-icon>arrow_downward</v-icon>
				</v-btn>
				<v-btn @click="handlePrizeRemove()" icon tabindex="-1">
					<v-icon>delete</v-icon>
				</v-btn>
			</v-flex>
		</div>
		<v-textarea :rows="1" :auto-grow="true" v-model="prize.description" label="Description"></v-textarea>
		<v-text-field type="number" class="number-input" v-model="prize.numberOfWinners" label="Number of Winners" :rules="rules.number"></v-text-field>
		<image-upload 
		 	label="Image" 
			class="pa-0 image-wrapper" 
			:class="{'-no-image': !prize.imageUrl}"
			:use-slot="true"
			v-model="prize.imageUrl">
			<v-img v-if="prize.imageUrl" class="img-preview elevation-1 mt-2" :src="prize.imageUrl" :contain="true" width="200" height="200"></v-img>
			<v-img v-else class="img-preview elevation-1 mt-2" :src="`https://www.jeban.com/images/1px.png`" :contain="true" width="200" height="200"></v-img>
		</image-upload>
		<label>ไอเท็มที่มีในรางวัลนี้</label>
		<related-products v-model="prize.products"></related-products>
		<label>เงื่อนไขในการคัดเลือก</label>
		<selected-criteria v-model="prize.criteria"></selected-criteria>
	</div>
</template>

<script>
	import * as config from '@/config'
    import * as types from '@/stores/mutation-types'

	import ImageUpload from '@/components/ImageUpload.vue'
	import RelatedProducts from '@/components/RelatedProducts.vue'
	import SelectedCriteria from '@/components/SelectedCriteria.vue'

	export default {
		components: {
			'image-upload': ImageUpload,
			'related-products': RelatedProducts,
			'selected-criteria': SelectedCriteria
		},
		props: {
			value: {
				type: Object,
				default: () => {}
			},
			disableMoveUp: {
				type:Boolean,
				default: false
			},
			disableMoveDown: {
				type:Boolean,
				default: false
			}
		},
		data () {
			return {
				rules: {
					text: [
						v => !!v || 'Field is required'
					],					
					number: [
						v => !!v || 'Field is required',
						v => (parseInt(v) > 0) || 'Value must be greater than 0'
					],					
				},

				prize: () => {},
			}
		},
		methods: {
			handlePrizeMoveUp () {
				this.$emit('moveUp')
			},
			handlePrizeMoveDown () {
				this.$emit('moveDown')
			},
			handlePrizeRemove () {
				this.$emit('remove')
			}
		},
		mounted () {
			this.prize = this.value
		},
		watch: {
			value: {
				handler (newValue) {
					if (newValue != this.prize) this.prize = newValue
				},
				deep: true
			},
			prize: {
				handler (newValue) {
					if (newValue != this.prize) this.$emit('input', this.prize)
				},
				deep: true
			}
		}
	}
</script>

<style lang="scss">
	.prize-edit {
		display: grid;
		grid-template-columns: 1fr auto;
		grid-column-gap: 1rem;

		.title {
			display: grid;
			grid-template-columns: 1fr auto;
		}

		.image-wrapper {
			grid-row: 1/4;
			grid-column: 2;

			margin-bottom: .5rem;
			position: relative;

			&.-no-image {
				.v-image {
					position: relative;

					&:after {
						content: 'Click to Upload';
						display: block;
						position: absolute;
						left: 50%;
						top: 50%;
						transform: translate(-50%, -50%);
					}
				}
			}

			.v-image {
				border: 1px solid rgba(0, 0, 0, .16);
				cursor: pointer;
			}
		}

		.related-products-inline,
		.selected-criteria-inline {
			grid-column: span 2;
			padding-right: 8px;

			.btn-add-product,
			.btn-add-criteria {
				bottom: 1.5rem;
			}
		}
	}
</style>